/* eslint-disable no-console */
<template>
    <div class="main_unit">
        <div v-if="isStoreManager" class="store_login_unit">{{brandStoreName}}</div>
        <div v-if="isCompanyManager" class="store_login_unit_manage_menu">企業管理者画面</div>
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div class="store_List_tbl_unit wd976 tbl_ht_none tbl_bg_blue" v-show="!isInitLoading">

            <Message v-if="apiValidationMessage" :validationMessage="apiValidationMessage" />

            <div v-if="auth == 3" class="admin_menu_top_unit">
                <div class="store_buttan_unit">
                    <div class="store_kanri_box">
                        <ul><li>
                            <router-link class="store_buttan_unit top_tit" :to="{ name: 'manageStoreAdd'} ">新規登録</router-link>
                        </li></ul>
                    </div>
                </div>
            </div>

            <div v-else-if="auth == 2" class="admin_menu_top_unit">
                <div v-if="storeContent.length" class="right_btn_csv">
                    <a href="#" @click.prevent.stop="csvOutput">CSV出力</a>
                </div>
                <div v-else class="right_btn_csv_disabled">
                    <a>CSV出力</a>
                </div>
            </div>

            <table>
                <tbody>
                <tr class="text-center">
                    <th class="wd240 border_bottom_none" style="min-width:240px" v-for="(value,key) in columns" :key="key" @click="sortBy(key)">
                        {{value}}
                        <img class="triangle" v-if="sortOrders[key] > 0" src="../assets/img/UnderTriangleWhite.png" width="15px" height="13px" alt="UnderTriangle">
                        <img class="triangle" v-if="sortOrders[key] <= 0" src="../assets/img/UpTriangleWhite.png" width="15px" height="13px" alt="UpTriangle">
                    </th>
                    <th class="wd495" style="min-width:495px" rowspan="2">店舗住所</th>
                    <th v-if="auth == 4" class="wd240" style="min-width:240px" rowspan="2">編集</th>
                    <th v-else-if="auth == 2" class="wd240" style="min-width:240px" rowspan="2">詳細</th>
                    <th v-else-if="auth == 3" class="wd240" style="min-width:240px" rowspan="2">編集/削除</th>
                </tr>
                <tr>
                    <th class="border_top_none"><input class="wd150" type="text" v-model="searchWord" placeholder="キーワード検索"> </th>
                </tr>
                <tr v-for="storeList in filteredDatas" :key="storeList.brandId">
                    <td class="text_white_space" v-for="(value,key) in columns" :key="key">
                        {{storeList[key]}}
                    </td>
                    <td class="text_white_space">{{storeList.address}}</td>
                    <td v-if="auth == 4" class="store_buttan_unit staff_kanri_box">
                        <ul class="ul_tbl_buttan">
                            <li>
                                <router-link class="store_buttan_unit" :to="{ name: 'manageStoreEdit', params: {id:storeList.storeId}} ">編集</router-link>
                            </li>
                        </ul>
                    </td>
                    <td v-else-if="auth == 2" class="store_buttan_unit staff_kanri_box">
                        <ul class="ul_tbl_buttan">
                            <li>
                                <router-link class="store_buttan_unit" @click.native="setStoreId(storeList.storeId)" :to="{ name: 'manageStoreDetail' }">詳細</router-link>
                            </li>
                        </ul>
                    </td>
                    <td v-else-if="auth == 3" class="store_buttan_unit staff_kanri_box">
                    </td>
                </tr>
                </tbody>

            </table>
        </div>

        <div class="overlay_loder2" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>

        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">CSV出力</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>CSV出力が完了しました。</p>
                    </div>
                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
export default {
    name: 'StoreList',
    components: {
        PulseLoader
    },
    data: function () {
        var columns = {
            storeName :"店舗名",
        };
        var sortOrders = {};
        Object.keys(columns).forEach(function (key) {
            sortOrders[key] = 1
        });
        return {
            isInitLoading:true,
            brandId: '',
            storeId: '',
            auth:'',
            columns:columns,
            sortKey:'',
            sortOrders:sortOrders,
            searchWord:'',
            storeContent: [],
            isLoading: false,
            apiValidationMessage: "",
            csvResponseData: [],
            showContent: false,
        }
    },
    created: function(){
        this.calc();
    },
    methods:{
        async calc(){
            //ブランドIDを取得
            this.brandId = this.$store.getters['manager/manager'].brandId;
            //権限情報を取得
            this.auth = this.$store.getters['manager/manager'].authorityKbn;

            var params = {}

            if(this.auth == 3 || this.auth == 4) {
                //ストアIDを取得
                this.storeId = this.$store.getters['store/id'];
                params.store_id = this.storeId;
            }
            // 管理画面店舗一覧取得API
            await this.$axios
                .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store', { params })
                .then(response => (this.storeContent = response['data']['storeList']))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}

                    if (this.auth == 4 && err.customError.code) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                    }

                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);
        },
        sortBy:function(key){
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;

        },
        setStoreId(id) {
            this.$store.dispatch('store/setStoreId', id)
        },

        //店舗一覧CSVファイル出力
        async csvOutput() {
            this.isLoading = true;
            this.apiValidationMessage = '';
            await this.$axios
                .get(this.$apiEndpoint + 'manage/store/csv', {params: {brand_id: this.brandId}})
                .then(response => (this.csvResponseData = response))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}

                    if (this.auth == 4 && err.customError.code) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                    }

                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isLoading = false);

            if(!this.commonDownloadCSV(this.csvResponseData)){
                this.apiValidationMessage =  "CSVの出力に失敗しました。";
                this.scrollTop();
            }
            else{
                this.showContent = true;
            }
        },

        closeModel: function(){
            this.showContent = false;
        },
    },
    computed:{
        filteredDatas:function(){
            var data = this.storeContent;

            var sortKey = this.sortKey;
            var order = this.sortOrders[sortKey] || 1;

            if(sortKey){
                data = data.slice().sort(function(a,b){
                    a = a[sortKey];
                    b = b[sortKey];
                    return(a === b ? 0 : a > b? 1 : -1) * order;
                });
            }

            var filterWord = this.searchWord && this.searchWord.toLowerCase();
            if(filterWord){
                data = data.filter(function (row){
                    return Object.keys(row).some(function (){
                        return String(row["storeName"]).toLowerCase().indexOf(filterWord) === 0
                    })
                })
            }

            return data;

        },
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        isCompanyManager: function () {
            return this.auth == 2
        },
        isStoreManager: function () {
            return this.auth == 4
        },
        brandStoreName: function () {
            let brandName = this.$store.getters['brand/name']
            let storeName = this.$store.getters['store/name']

            if (brandName == null) {
                brandName = ''
            }

            if (storeName == null) {
                storeName = ''
            }

            return brandName + '・' + storeName
        },
    }
}
</script>